import { QueryRefetchInterval } from '@cast/shared-types';
import { OmniCluster } from '@cast/types-omni';

import { isClusterOmniEnabled } from 'utils/cluster';

import { useGetOmniClusterFromList } from './useGetOmniClusterFromList';

export const useIsClusterOmniEnabled = ({
  clusterId,
  refetchInterval,
}: {
  clusterId: string;
  refetchInterval?: QueryRefetchInterval<OmniCluster[]>;
}) => {
  const { clusterDetails, isLoading } = useGetOmniClusterFromList({
    clusterId,
    enabled: !!clusterId,
    refetchInterval,
  });

  return {
    isClusterOmniEnabled: isClusterOmniEnabled(clusterDetails),
    clusterDetails,
    isLoading,
  };
};
